import { useEffect, useState } from "react";
import { BsShop } from "react-icons/bs";
import { FaBell, FaRegUser } from "react-icons/fa6";
import { FiPhoneCall } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoTodayOutline } from "react-icons/io5";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { DynamicForm } from "../../../../components/new-formbuilder/form";
import { useNavigate } from "react-router-dom";
import { getMonthStartAndEndDates } from "../../../../app/utility/monthStartEndDate";
import { CRMService } from "../../../../app/core/crm.service";
import { FormatIndianDate } from "../../../../app/utility/formatIndianDate";
import toast from "react-hot-toast";


export const VendorsList = () => {
  const navigate = useNavigate();
  const { startDate, endDate } = getMonthStartAndEndDates();
  const [loading, setLoading] = useState<any>(false);
  const [inputValue, setInputValue] = useState("");
  const [fromDate, setFromDate] = useState<any>(startDate);
  const [toDate, setToDate] = useState<any>(endDate);
  const [customerList, setCustomerList] = useState<any>([]);

  const customerFormData = [
    {
      title: "input",
      control: "",
      type: "text",
      label: "Shop Name",
      name: "shop_name",
      value: "",
      required: true,
      regex: /^(?!\s*$).+/,
      maxLength: "",
      placeholder: "Please enter shop name",
      error: "Please enter shop name",
      submitButtonName: "Add",
      hideMandatoryStar: false,
    },
    {
      title: "input",
      control: "",
      type: "text",
      label: "Owner Name",
      name: "name",
      value: "",
      required: true,
      regex: /^(?!\s*$).+/,
      maxLength: "",
      placeholder: "Please enter owner name",
      error: "Please enter owner name",
      submitButtonName: "Add",
      hideMandatoryStar: false,
    },
    {
      title: "input",
      control: "",
      type: "text",
      label: "Mobile Number",
      name: "contact",
      value: "",
      required: true,
      regex: /^[6-9]\d{9}$/,
      maxLength: "",
      placeholder: "Please enter mobile number",
      error: "Please enter a valid 10-digit mobile number",
      submitButtonName: "Add",
      hideMandatoryStar: false,
    },
    {
      title: "input",
      control: "",
      type: "text",
      label: "Alternate Mobile Number",
      name: "alternative_contact_no",
      value: "",
      required: false,
      regex: /^[6-9]\d{9}$/,
      maxLength: "",
      placeholder: "Please enter alternate mobile number",
      error: "Please enter a valid 10-digit alternate mobile number",
      submitButtonName: "Add",
      hideMandatoryStar: false,
    },
    {
      title: "textarea",
      control: "",
      type: "text",
      label: "Address",
      name: "address",
      value: "",
      rows: 4,
      required: true,
      regex: /^(?!\s*$).+/,
      maxLength: "",
      placeholder: "Please enter address",
      error: "Please enter a valid address",
      submitButtonName: "Add",
      hideMandatoryStar: false,
    },
    {
      type: "button",
      class: "col-md-12 d-flex justify-content-center my-2",
      buttons: [
        {
          title: "Add",
          action: "add",
          isCheckFormValidation: true,
          class: "btn btn-primary rounded-pill border-0 w-25",
        },
      ],
    },
  ];

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    let payload = {
      ...(startDate && { DateFrom: startDate }),
      ...(endDate && { DateTo: endDate }),
    }
    getCustomers(payload);
  }, []);

  const getCustomers = async (payload: any) => {
    try {
      const res = await CRMService.GET_CUSTOMERS(payload);
      setCustomerList(res?.results || [])
    }
    catch (err) {
    }
  }

  const onFormSubmitEvent = async (event: any) => {
    try {
      const formData = event.formData;
      const payload = {
        shop_name: formData?.shop_name,
        name: formData?.name,
        contact: formData?.contact,
        alternative_contact_no: formData?.alternative_contact_no,
        address: formData?.address
      };
      const res = await CRMService.CREATE_CUSTOMERS(payload);
      if (res) {
        let payload = {
          ...(inputValue?.length > 0 && { search: inputValue }),
          ...(fromDate && { DateFrom: fromDate }),
          ...(toDate && { DateTo: toDate }),
        }
        getCustomers(payload);
        handleClose();
        toast.success('customer created successfully');
      }
    }
    catch (err) { }
  }

  const showDetails = (value: any) => {
    navigate(`/dashboard/crm/vendors-list/${value._id}/tasks-follows`);
  };

  const handleChange = (e: any) => {
    const value = e.target.value;
    let payload = {
      ...(value?.length > 0 && { search: value }),
      ...(fromDate && { DateFrom: fromDate }),
      ...(toDate && { DateTo: toDate }),
    }
    getCustomers(payload);
    setInputValue(value);
  }

  const selectFromDate = (e: any) => {
    setFromDate(e.target.value);
  }

  const selectToDate = (e: any) => {
    setToDate(e.target.value)
  }

  const searchData = () => {
    let payload = {
      ...(inputValue?.length > 0 && { search: inputValue }),
      ...(fromDate && { DateFrom: fromDate }),
      ...(toDate && { DateTo: toDate }),
    }
    getCustomers(payload);
  }

  const handleClearData = () => {
    setInputValue('');
    setFromDate(startDate);
    setToDate(endDate);
    const payload = {
      ...(startDate && { DateFrom: startDate }),
      ...(endDate && { DateTo: endDate }),
    };
    getCustomers(payload);
  }

  return (
    <div className="container-fluid content-bg-color">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold primary-color mt-3">Customer List</h5>
        <div className="align-items"><FaBell className="me-2 cursor-pointer" size={22} onClick={() => { navigate(`/dashboard/crm/vendors-list/reminders`) }} /><button className="btn btn-primary" onClick={handleShow}>Add Customer</button></div>
      </div>
      <div className="row mx-1">
        <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search ..." />
        <div className="row mt-2">
          <div className="col-md-5 mb-2 ps-0">
            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
          </div>
          <div className="col-md-5 mb-2">
            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
          </div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={searchData}>Search</button></div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={handleClearData}>Clear</button></div>
        </div>
      </div>
      {loading && (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}
      {!loading && <div>
        <div className="row">
          {customerList.map((value: any, index: any) => (
            <div className="col-md-6 mb-2" key={index}>
              <div className="card rounded-4 box-shadow">
                <div className="card-body py-2">
                  <div className="row align-items">
                    <div className="col-1"><BsShop className="me-2" size={20} /></div>
                    <div className="col-11 ps-0">{value.shop_name}</div>
                    <div className="col-1"><FaRegUser className="me-2" size={20} /></div>
                    <div className="col-11 ps-0">{value.name}</div>
                    <div className="col-1"><FiPhoneCall className="me-2" size={20} /></div>
                    <div className="col-11 ps-0">{value?.contact}</div>
                    <div className="col-1"><HiOutlineLocationMarker className="me-2" size={20} /></div>
                    <div className="col-11 ps-0">{value.address}</div>
                  </div>
                  <div className="d-flex justify-content-between align-items"><div><b>Created Date</b> : {FormatIndianDate(value?.created_date, "")}</div><div className="text-end"><button className="text-white primary-bg rounded border-0 fs-14 px-3" onClick={() => showDetails(value)}>View</button></div></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>}
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Customer</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <DynamicForm
            userFormData={customerFormData}
            columns={1}
            isEdit={false}
            onFormSubmitEvent={(e) => onFormSubmitEvent(e)}
            loading={loading}
            isNotEmptyFormAfterSubmit={true}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};
